import React, { useState, useEffect } from "react";
import { useEditForm } from "../useEditForm";
import { Input } from "../Input";
import { make_role_options } from "../util";
import { TYPE, ACTION } from "../URL";
import Button from 'react-bootstrap/Button';

export default function UserInsert() {
  const fields = [
    { name: "name",     label: "名前" },
    { name: "email",    label: "メールアドレス" },
    { name: "password", label: "パスワード" },
    { name: "role",     label: "権限", options: make_role_options() }
  ];

  const names   = fields.map(field => field.name);

  const user_id = 0;
  const [data]  = useState({});
  const { register, handleSubmit, errors, formData, setFormData } = useEditForm(data, names, TYPE.USER, ACTION.INSERT, user_id);
  
  useEffect(() => {
    setFormData(data);
  }, [data, setFormData]);
  
  return (
    <form onSubmit={handleSubmit}>
      <table>
        <tbody>
        {fields.map((field) => (
          <tr key={field.name}>
            <Input
              name        = {field.name}
              label       = {field.label}
              options     = {field.options}
              formData    = {formData}
              setFormData = {setFormData}
              register    = {register}
              errors      = {errors}
            />
          </tr>
        ))}
        </tbody>
      </table>
      <Button type="submit">作成</Button>
    </form>
  );
}
